import React, { useState } from 'react';

import {
  TemplateSelect,
  CountrySelect,
  Modal
} from '../../components';

import './select-calculation-data-modal.css';

const SelectCalculationDataModal = ({
  onSave,
  onCancel,
  isOpen
}) => {

  const [country, setCountry] = useState(null);
  const [countryError, setCountryError] = useState('');
  const [templateError, setTemplateError] = useState('');
  const [template, setTemplate] = useState('');


  const onChange = (fnc) => {
    if (fnc === 'template') {
      return (value) => {
        if (value) {
          setTemplateError('');
        }
        setTemplate(value);
      }
    }

    if (fnc === 'country') {
      return (value) => {
        setCountryError('');
        setCountry(value);
      }
    }
  }

  const onSaveLocal = () => {
    let ok = true;

    if (!country) {
      setCountryError('Choose a country!');
      ok = false;
    }

    if (!template) {
      setTemplateError('Select a template!');
      ok = false;
    }

    if (ok) {
      onSave({ country, template });
    }
  }

  const onCancelLocal = () => {
    setCountry(null);
    setCountryError('');
    setTemplateError('');
    setTemplate('');
    onCancel();
  }

  let errorHtml = false;
  if (countryError || templateError) {
    errorHtml = (
      <div className="select-calc-data-modal-error-html font-color-error1">
        {countryError ? <h4>{countryError}</h4> : false}
        {templateError ? <h4>{templateError}</h4> : false}
      </div>
    )
  }

  let selectedCountry = false;
  if (country) {
    selectedCountry = (
      <div className="selected-country-display">
        <img src={country[1]} alt={country[0]} />
        <p>{country[0]}</p>
      </div>
    )
  }

  return (
    <Modal isOpen={isOpen} onClose={onCancelLocal} className="modal-content-default select-calculation-data-modal">
      <div className="font-color2">
        <h2>Select a template and a country to make a calculation:</h2>
        {errorHtml}
        <div className="select-country-wrapper">
          <div className="form-group">
            <label>Start typing a country:</label>
            <CountrySelect onSelect={onChange('country')} />
          </div>
          {selectedCountry}
        </div>
        <div className="form-group">
          <label>Select a template:</label>
          <TemplateSelect value={template._id} autoSelectIf1 onChange={onChange('template')} />
        </div>
        <div className="modal-controls">
          <button className="btn btn-default-cancel" onClick={onCancelLocal} type="button">Cancel</button>
          <button className="btn btn-default-ok" onClick={onSaveLocal} type="button">Save</button>
        </div>
      </div>
    </Modal>
  )
}

export default SelectCalculationDataModal;